import React from 'react'
import PaymentBackButton from '../components/PaymentBackButton/PaymentBackButton'
import PaymentPriceCard from '../components/PaymentPriceCard/PaymentPriceCard'
import PaymentCard from '../components/PaymentCard/PaymentCard'
import { useLanguage } from '../../../LanguageProvider';

export default function Payment({ setCurrentPage, specs, title, price, userCountry, selectedPriceNumeric, selectedLabel }) {
      const { getTranslation } = useLanguage();
    
    return (
        <div className="custom-plan-container">
            <div className="custom-plan-content">
                <div className="custom-plan-inner-content">

                    <div style={{ width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>

                        <div style={{ flexDirection: 'column', display: 'flex' }}>
                            <span className='custom-plan-title'>{getTranslation("viewPlans")}</span>
                            <span className='custom-plan-subtitle'>{getTranslation("choosePlan")}</span>
                        </div>

                        <PaymentBackButton setCurrentPage={setCurrentPage} />

                    </div>

                    <div style={{ height: '100%', width: '100%', flexDirection: 'row', alignItems: 'flex-start', display: 'flex', gap: '19px', justifyContent: 'center' }}>
                        <PaymentPriceCard specs={specs} title={title} price={price} />
                        <PaymentCard userCountry={userCountry} setCurrentPage={setCurrentPage} selectedPriceNumeric={selectedPriceNumeric} selectedLabel={selectedLabel}/>
                    </div>
                </div>
            </div>
        </div>
    )
}
